export const channelContentCssPath = '.channel-content';
export const channelFormCssPath = '.channel-form';
export const channelFormTitleCssPath = '.channel-form-title';
export const channelFormIdCssPath = '.form-channel-id';
export const channelFormNameCssPath = '.form-channel-name';
export const channelFormTypeCssPath = '.form-channel-type';
export const channelFormSaveBtnCssPath = '.form-save-channel-btn';
export const channelFormCancelBtnCssPath = '.form-cancel-channel-btn';
export const channelFormEmailChannelCssPath = '.form-channel-email';
export const channelFormEmailSubjectCssPath = '.form-channel-email-subject';
export const channelFormEmailBodyCssPath = '.form-channel-email-body';
export const channelFormSMSCssPath = '.form-channel-sms';
export const channelFormSMSMessageCssPath = '.form-channel-sms-message';
export const behaviorOpenFormChannel = '.behavior-open-form-channel';
export const channelsTable = '.channels-table';
